(function (angular, app) {
    'use strict';

    var NUMBER_SHOWN_ITEMS = 6

    app.controller('AddGiftCardCtrl', [
        '$rootScope', '$scope', '$filter', '$timeout', 'Config', 'Cart', 'PaymentsService', 'options', 'Dialog', 'SP_PAYMENTS', 'User', 'Util', 'summaryCtrl',
        function ($rootScope, $scope, $filter, $timeout, Config, Cart, PaymentsService, options, dialog, SP_PAYMENTS, user, util, summaryCtrl) {
            var addGiftCardCtrl = this,
                _listeners = [],
            sortType = {
                'ASC': 0,
                'DESC': 1
            },
            _roundCurrencyFilter = $filter('roundCurrency');
            //addGiftCardCtrl.redeemedGiftCards = options.redeemedGiftCards || {};
            addGiftCardCtrl.mainPaymentMethod = options.mainPaymentMethod;
            addGiftCardCtrl.maxAmount = options.maxAmount || null;
            addGiftCardCtrl.giftCardsData = options.giftCardsData || {};
            addGiftCardCtrl.removedGiftCards = [];
            addGiftCardCtrl.giftCardsIndex = {};
            addGiftCardCtrl.giftCardsSettings = Config.retailer.settings.giftCardsSettings ? util.tryParseJson(Config.retailer.settings.giftCardsSettings) : {};
            addGiftCardCtrl.total = Cart.total.finalPriceWithTax + Cart.total.serviceFee.finalPriceWithTax + Cart.total.deliveryCost.finalPriceWithTax;
            addGiftCardCtrl.giftCardPopupSettings = Config.retailer.settings.checkoutDisplaySettings ? util.tryParseJson(Config.retailer.settings.checkoutDisplaySettings) : {};
            //addGiftCardCtrl.selectedGiftCard = addGiftCardCtrl.giftCards[0].paymentMethodId;
            addGiftCardCtrl.giftCardInputRegExp = new RegExp(/^[0-9.-]*$/);
            addGiftCardCtrl.carouselActions = {
                toggleSelectedGiftCard: toggleSelectedGiftCard,
                showAddCardDialog: showAddCardDialog
            };
            addGiftCardCtrl.toggleEllipsisBtn = toggleEllipsisBtn;
            addGiftCardCtrl.toggleSelectedGiftCard = toggleSelectedGiftCard;
            addGiftCardCtrl.showAddCardDialog = showAddCardDialog;
            addGiftCardCtrl.checkGiftCard = checkGiftCard;
            addGiftCardCtrl.redeemGiftCard = redeemGiftCard;
            addGiftCardCtrl.removeCard = removeCard;
            addGiftCardCtrl.isDisableRedeemBtn = isDisableRedeemBtn;
            addGiftCardCtrl.checkAmount = checkAmount;
            addGiftCardCtrl.resetCardDetails = resetCardDetails;
            addGiftCardCtrl.isGiftCardNotEligible = isGiftCardNotEligible;
            addGiftCardCtrl.next = next;
            addGiftCardCtrl.close = close;
            addGiftCardCtrl.isRedeemedGiftCardsExist = isRedeemedGiftCardsExist;
            addGiftCardCtrl.legalText = {};
            addGiftCardCtrl.isValidateCvv = isValidateCvv;
            addGiftCardCtrl.isShowImagesGiftCards = Config.retailer.settings.isShowImagesGiftCards === 'true';
            addGiftCardCtrl.giftCardAccessibilities = Config.retailer.settings.giftCardAccessibilities ? util.tryParseJson(Config.retailer.settings.giftCardAccessibilities) : {};
            addGiftCardCtrl.giftCardOrders = Config.retailer.settings.giftCardOrders ? Config.retailer.settings.giftCardOrders.split(',') : [];
            addGiftCardCtrl.numberScrolledItems = Config.retailer.settings.isScrollFullGiftCards === 'true' ? NUMBER_SHOWN_ITEMS : 1;
            addGiftCardCtrl.isScrollWhenClickOnLastItem = Config.retailer.settings.isScrollFullGiftCards === 'true';
            addGiftCardCtrl.allowAddMultipleGiftCardsByType = allowAddMultipleGiftCardsByType;
            addGiftCardCtrl.getRedeemedGiftCardsByType = getRedeemedGiftCardsByType;

            addGiftCardCtrl.addAnotherCard = addAnotherCard;
            addGiftCardCtrl.getGridColumns = getGridColumns;
            addGiftCardCtrl.allowAddMultipleGiftCardsByTypeSettings = allowAddMultipleGiftCardsByTypeSettings;
            addGiftCardCtrl.hasMaximumNumberOfGiftCardsReachedForThisType = hasMaximumNumberOfGiftCardsReachedForThisType;

            _init();

            function _init() {
                if(options.isUsedCashbackPoints) {
                    addGiftCardCtrl.total -= options.availableUserCashback;
                }
                _initGiftCardsCarousel();
                _setGiftCardsData();
                _calculateBalanceToBePayed();
                _calculateTextTruncation();
                _setGiftCardGeneralDisplay();
                $timeout(function () { // Wait for carousel to render before adjusting pointer
                    _setGiftCardDisplay(options.isAddingNewCard || false);
                }, 500);
                summaryCtrl._removeRedeemedGiftCard = addGiftCardCtrl.removeCard;

            }

            function toggleEllipsisBtn() {
                addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore = !addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore;

                if(addGiftCardCtrl.giftCardDisplay && addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore && addGiftCardCtrl.originalLegalText) {
                    addGiftCardCtrl.giftCardDisplay.legalText = addGiftCardCtrl.originalLegalText;
                } else {
                    addGiftCardCtrl.giftCardDisplay.legalText = addGiftCardCtrl.truncatedLegalText;
                }
            }

            function toggleSelectedGiftCard (giftCardId, giftCardPosition) {
                if(addGiftCardCtrl.carouselData.selectedGiftCard === giftCardId) return;

                addGiftCardCtrl.carouselData.selectedGiftCard = giftCardId;
                addGiftCardCtrl.carouselData.selectedGiftCardData = addGiftCardCtrl.giftCards[addGiftCardCtrl.giftCardsIndex[giftCardId]];

                if (addGiftCardCtrl.carouselData.selectedGiftCard === SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD ||
                    addGiftCardCtrl.carouselData.selectedGiftCard === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI
                ) {
                    var isAllowAddMultipleGiftCardsByType = allowAddMultipleGiftCardsByType(giftCardId);
                    var isGiftCardDataEmpty = (util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, giftCardId + '.cards.length') || 0) === 0 ? true : false;
                    if (!isAllowAddMultipleGiftCardsByType || isGiftCardDataEmpty) {
                        return showAddCardDialog(giftCardId);
                    }
                }

                _setGiftCardDisplay();

                $scope.$broadcast('clickItemCarousel', {
                    indexItem: giftCardPosition,
                    callback: _adjustPointerPosition
                });
            }

            function showAddCardDialog(giftCardId) {
                if (addGiftCardCtrl.giftCardsData[giftCardId] && addGiftCardCtrl.giftCardsData[giftCardId].token || addGiftCardCtrl.carouselData.redeemedGiftCards[giftCardId] && addGiftCardCtrl.carouselData.redeemedGiftCards[giftCardId].token) {
                    if (giftCardId === SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD || giftCardId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI) {
                        _setGiftCardDisplay();
                        return;
                    }
                    addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore = false;
                    addGiftCardCtrl.carouselData.selectedGiftCard = giftCardId;
                    return;
                }

                // Open iframe when the max gift card has not been added
                dialog.hide(addGiftCardCtrl.carouselData.redeemedGiftCards);
                if(Config.retailer.settings.useDeliveryAddressAsBilling && summaryCtrl.compiledUserAddress) {
                    return dialog.show({
                        templateUrl: 'template/dialogs/use-delivery-address-as-billing/index.html',
                        controller: ['$scope', function ($dialogScope) {
                            var dialogCtrl = this;
                            dialogCtrl.sendUserAddress = false;
                            dialogCtrl.compiledUserAddress = summaryCtrl.compiledUserAddress;
                            var userAddress = user.data.addresses[0];
                            var userCountryName = userAddress && userAddress.country
                            if (userCountryName) {
                                userAddress.countryCode = util.getCountryCode(userCountryName);
                            }
                            $dialogScope.continue = function () {
                                var options = {
                                    sendUserAddress: dialogCtrl.sendUserAddress,
                                    address: userAddress.text1 ? userAddress.text1 : userAddress.text2 ? userAddress.text2 : '',
                                    city: userAddress.city ? userAddress.city : '',
                                    country: userAddress.country ? userAddress.country : '',
                                    countryCode: userAddress.countryCode ? userAddress.countryCode : '',
                                };

                                if (giftCardId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI) {
                                    return setFinitiCard(giftCardId, options, true);
                                } else if (giftCardId === SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD) {
                                    return setMaxGiftCard(giftCardId, options, true);
                                }
                            };
                        }],
                        controllerAs: 'dialogCtrl',
                        styleClass: 'clear-cart-popup'
                    });
                } else if (giftCardId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI) {
                    return setFinitiCard(giftCardId, {}, true);
                } else {
                    return setMaxGiftCard(giftCardId, {}, true);
                }
            }

            function getRedeemedGiftCardsByType(paymentMethodId) {
                return util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.cards') || [];
            }

            function allowAddMultipleGiftCardsByTypeSettings(paymentMethodId) {
                var giftCardDisplay = util.tryParseJson(Config.retailer.settings.giftCardDisplay) || {};
                var allowSameGiftCardTypeMultipleTimes = util.getDataByPath(giftCardDisplay, Config.language.culture + '.config.' + paymentMethodId + '.allowSameGiftCardTypeMultipleTimes') || false;
                return allowSameGiftCardTypeMultipleTimes;
            }

            function hasMaximumNumberOfGiftCardsReachedForThisType(paymentMethodId) {
                var giftCardDisplay = util.tryParseJson(Config.retailer.settings.giftCardDisplay) || {};
                var giftCardTypeRedemptionLimit = util.getDataByPath(giftCardDisplay, Config.language.culture + '.config.' + paymentMethodId + '.giftCardTypeRedemptionLimit') || 3;
                var isLimitedToUseGiftCardTypeRedemption = util.getDataByPath(giftCardDisplay, Config.language.culture + '.config.' + paymentMethodId + '.isLimitedToUseGiftCardTypeRedemption') || false;
                var currentGiftCardCount = util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.cards.length') || 0;
                return isLimitedToUseGiftCardTypeRedemption && currentGiftCardCount >= giftCardTypeRedemptionLimit;
            }
            
            function allowAddMultipleGiftCardsByType(paymentMethodId) {

                var currentGiftCardCount = util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.cards.length') || 0;
                var giftCardDisplay = util.tryParseJson(Config.retailer.settings.giftCardDisplay) || {};
                var allowSameGiftCardTypeMultipleTimes = util.getDataByPath(giftCardDisplay, Config.language.culture + '.config.' + paymentMethodId + '.allowSameGiftCardTypeMultipleTimes') || false;
                var isLimitedToUseGiftCardTypeRedemption = util.getDataByPath(giftCardDisplay, Config.language.culture + '.config.' + paymentMethodId + '.isLimitedToUseGiftCardTypeRedemption') || false;
                var giftCardTypeRedemptionLimit = util.getDataByPath(giftCardDisplay, Config.language.culture + '.config.' + paymentMethodId + '.giftCardTypeRedemptionLimit') || 3;
                var currentCardNumber = util.getDataByPath(addGiftCardCtrl.giftCardsData, paymentMethodId + '.number') || '';
                if(currentCardNumber.length > 0) {
                    return false;
                }
                if (isLimitedToUseGiftCardTypeRedemption) {
                    return currentGiftCardCount < giftCardTypeRedemptionLimit && addGiftCardCtrl.carouselData.balanceToBePayed > 0;
                }
                return allowSameGiftCardTypeMultipleTimes && addGiftCardCtrl.carouselData.balanceToBePayed > 0;
            }

            function getGridColumns(paymentMethodId) {
                var result = '220px';
                if (allowAddMultipleGiftCardsByTypeSettings(addGiftCardCtrl.carouselData.selectedGiftCard) 
                    && addGiftCardCtrl.carouselData.redeemedGiftCards[addGiftCardCtrl.carouselData.selectedGiftCard]
                    && !addGiftCardCtrl.carouselData.redeemedGiftCards[addGiftCardCtrl.carouselData.selectedGiftCard].isAddingNewCard) {
                    result += ' 160px';
                }
                result += ' auto';
                return result;
            }
            function addAnotherCard(paymentMethodId, card) {
                if (hasMaximumNumberOfGiftCardsReachedForThisType(paymentMethodId)) {
                    return false;
                }
                card = angular.extend({}, card);
                if (!card.cardNumber) {
                    var isAddingNewCard = util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.isAddingNewCard') || false;
                    if(!isAddingNewCard && (paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD || paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI)) {
                        return showAddCardDialog(paymentMethodId);
                    }
                    if(getRedeemedGiftCardsByType(paymentMethodId).length === 0) {
                        return false;
                    }
                    addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId] = angular.extend({}, addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId], {
                        isAddingNewCard: !isAddingNewCard
                    });
                    return false;
                }

                if (!addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId] || !addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].cards) {
                    addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId] = {
                        cards: [card],
                        amount: card.amount || 0,
                        isAddingNewCard: false
                    };
                } else {
                    if (addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId] && addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].cards.some(function (c) { return c.cardNumber === card.cardNumber; })) {
                        addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = 'gift_card_already_added';
                        return false;
                    }
                    else {
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].cards.push(card);
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount = _roundCurrencyFilter(addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount + Number(card.amount || 0));
                        if (addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount > addGiftCardCtrl.carouselData.balanceToBePayed) {
                            addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount = addGiftCardCtrl.carouselData.balanceToBePayed;
                        }
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].isAddingNewCard = false;
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].methodId = paymentMethodId;
                    }
                }
                
                return true;
            }

            function checkGiftCard (paymentMethodId) {
                addGiftCardCtrl.giftCardsData[paymentMethodId] = angular.extend({}, addGiftCardCtrl.giftCardsData[paymentMethodId]);
                addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = '';
                var cardNumber = addGiftCardCtrl.giftCardsData[paymentMethodId].number;
                var cvv = addGiftCardCtrl.giftCardsData[paymentMethodId].cvv;
                var giftCard = findGiftCard(paymentMethodId);
                var finalizedNumber = giftCard && giftCard.isCvvRequired &&
                paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.NOFSHONIT ? cardNumber + cvv : cardNumber;

                return PaymentsService.getGiftCardBalance(paymentMethodId, finalizedNumber)
                  .then(function (result) {
                      addGiftCardCtrl.giftCardsData[paymentMethodId].balance = _roundCurrencyFilter(result.balance);
                      addGiftCardCtrl.giftCardsData[paymentMethodId].token = result.token;
                      addGiftCardCtrl.giftCardsData[paymentMethodId].lastFourDigits = result.lastFourDigits || (addGiftCardCtrl.giftCardsData && addGiftCardCtrl.giftCardsData[paymentMethodId].number && addGiftCardCtrl.giftCardsData[paymentMethodId].number.slice(-4));
                      addGiftCardCtrl.giftCardsData[paymentMethodId].amount = _roundCurrencyFilter(addGiftCardCtrl.giftCardsData[paymentMethodId].balance < addGiftCardCtrl.carouselData.balanceToBePayed ? addGiftCardCtrl.giftCardsData[paymentMethodId].balance : addGiftCardCtrl.carouselData.balanceToBePayed);
                      addGiftCardCtrl.maxAmount = addGiftCardCtrl.giftCardsData[paymentMethodId].amount;

                  }).catch(function () {
                      addGiftCardCtrl.giftCardsData[paymentMethodId] = angular.extend({}, addGiftCardCtrl.giftCardsData[paymentMethodId], { errorMessage : 'gift_card_error_message'});
                  });
            }

            function setMaxGiftCard(paymentMethodId, additionalData, isAddingNewCard) {
                return PaymentsService.addMaxGiftCard(additionalData)
                  .then(function (result) {
                      if (result.paymentData) {
                          // addGiftCardCtrl.giftCardsData[paymentMethodId].balance = null;
                          addGiftCardCtrl.giftCardsData[paymentMethodId] = angular.extend({}, addGiftCardCtrl.giftCardsData[paymentMethodId]);
                          addGiftCardCtrl.giftCardsData[paymentMethodId].token = result.paymentData.token;
                          addGiftCardCtrl.giftCardsData[paymentMethodId].number = result.paymentData.cardNumber;
                          addGiftCardCtrl.giftCardsData[paymentMethodId].lastFourDigits = result.paymentData.lastFourDigits;
                          addGiftCardCtrl.giftCardsData[paymentMethodId].queryTransId = result.paymentData.queryTransId;
                          addGiftCardCtrl.giftCardsData[paymentMethodId].amount = _roundCurrencyFilter(addGiftCardCtrl.carouselData.balanceToBePayed);
                          addGiftCardCtrl.giftCardsData[paymentMethodId].isCvvRequired = false;
                          addGiftCardCtrl.maxAmount = _roundCurrencyFilter(addGiftCardCtrl.carouselData.balanceToBePayed);
                          if (result.paymentData.balance) {
                              addGiftCardCtrl.giftCardsData[paymentMethodId].balance = _roundCurrencyFilter(result.paymentData.balance);
                              addGiftCardCtrl.giftCardsData[paymentMethodId].amount = addGiftCardCtrl.giftCardsData[paymentMethodId].balance;
                              if (addGiftCardCtrl.maxAmount < addGiftCardCtrl.giftCardsData[paymentMethodId].amount) {
                                  addGiftCardCtrl.giftCardsData[paymentMethodId].amount = addGiftCardCtrl.maxAmount;
                              }
                          }
                          var payload = {
                              giftCards: options.giftCards,
                              giftCardsData: angular.copy(addGiftCardCtrl.giftCardsData),
                              redeemedGiftCards: angular.copy(addGiftCardCtrl.carouselData.redeemedGiftCards),
                              maxAmount: addGiftCardCtrl.maxAmount,
                              selectedGiftCard: paymentMethodId,
                              mainPaymentMethod: options.mainPaymentMethod,
                              isUsedCashbackPoints: options.isUsedCashbackPoints,
                              availableUserCashback: options.availableUserCashback,
                              isAddingNewCard: isAddingNewCard
                          }
                          return dialog.show({
                              templateUrl: 'template/dialogs/add-gift-card/index.html',
                              controller: 'AddGiftCardCtrl',
                              controllerAs: 'addGiftCardCtrl',
                              ariaLabelledby: 'add_gift_card_title',
                              styleClass: 'add-gift-cards-dialog',
                              clickOutsideToClose: false,
                              disableClosing: true,
                              locals: { options: payload },
                              resolve: {
                                  summaryCtrl: summaryCtrl
                              }
                          })
                      } else {
                          console.log('Cannot open gift card dialog')
                          backToGiftCardsList(paymentMethodId);
                      }
                  })
                  .catch(function (error) {
                      console.log("gift_card_error_message", error);
                      addGiftCardCtrl.giftCardsData[paymentMethodId] = angular.extend({}, addGiftCardCtrl.giftCardsData[paymentMethodId],{errorMessage : 'gift_card_error_message'});
                  });
            }

            function redeemGiftCard(paymentMethodId) {
                if (paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD || paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI) {
                    if (!addGiftCardCtrl.giftCardsData[paymentMethodId].cvv || isNaN(addGiftCardCtrl.giftCardsData[paymentMethodId].cvv)) {
                        addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired = true;
                        return;
                    } else {
                        addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired = false;
                    }
                }

                if(addGiftCardCtrl.removedGiftCards[paymentMethodId]) {
                    delete addGiftCardCtrl.removedGiftCards[paymentMethodId];
                }

                var card = {
                    methodId: paymentMethodId,
                    amount: addGiftCardCtrl.giftCardsData[paymentMethodId].amount,
                    cardNumber: addGiftCardCtrl.giftCardsData[paymentMethodId].number,
                    token: addGiftCardCtrl.giftCardsData[paymentMethodId].token,
                    lastFourDigits: addGiftCardCtrl.giftCardsData[paymentMethodId].lastFourDigits,
                    cvv: addGiftCardCtrl.giftCardsData[paymentMethodId].cvv,
                    queryTransId: addGiftCardCtrl.giftCardsData[paymentMethodId].queryTransId,
                    paymentsNumber: 1
                };
                if(!addAnotherCard(paymentMethodId, card)) {
                    return;
                }

                addGiftCardCtrl.carouselData.balanceToBePayed = _roundCurrencyFilter(addGiftCardCtrl.carouselData.balanceToBePayed - addGiftCardCtrl.giftCardsData[paymentMethodId].amount);
                addGiftCardCtrl.giftCardsData[paymentMethodId] = null;
            }

            function setFinitiCard(paymentMethodId, additionalData, isAddingNewCard) {
                return PaymentsService.addFinitiCard(additionalData)
                    .then(function (result) {
                        if (result.paymentData) {
                            addGiftCardCtrl.giftCardsData[paymentMethodId] = angular.extend({}, addGiftCardCtrl.giftCardsData[paymentMethodId]);
                            addGiftCardCtrl.giftCardsData[paymentMethodId].token = result.paymentData.token;
                            addGiftCardCtrl.giftCardsData[paymentMethodId].number = result.paymentData.cardNumber;
                            addGiftCardCtrl.giftCardsData[paymentMethodId].lastFourDigits = result.paymentData.lastFourDigits;
                            addGiftCardCtrl.giftCardsData[paymentMethodId].queryTransId = result.paymentData.queryTransId;
                            addGiftCardCtrl.giftCardsData[paymentMethodId].amount = _roundCurrencyFilter(addGiftCardCtrl.carouselData.balanceToBePayed);
                            addGiftCardCtrl.giftCardsData[paymentMethodId].isCvvRequired = false;
                            addGiftCardCtrl.maxAmount = _roundCurrencyFilter(addGiftCardCtrl.carouselData.balanceToBePayed);
                            if (result.paymentData.balance) {
                                addGiftCardCtrl.giftCardsData[paymentMethodId].balance = _roundCurrencyFilter(result.paymentData.balance);
                                addGiftCardCtrl.giftCardsData[paymentMethodId].amount = addGiftCardCtrl.giftCardsData[paymentMethodId].balance;
                                if (addGiftCardCtrl.maxAmount < addGiftCardCtrl.giftCardsData[paymentMethodId].amount) {
                                    addGiftCardCtrl.giftCardsData[paymentMethodId].amount = addGiftCardCtrl.maxAmount;
                                }
                                addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = ''
                            } else {
                                addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = 'could_not_load_balance_error_message'
                            }

                            var payload = {
                                giftCards: options.giftCards,
                                giftCardsData: angular.copy(addGiftCardCtrl.giftCardsData),
                                redeemedGiftCards: angular.copy(addGiftCardCtrl.carouselData.redeemedGiftCards),
                                maxAmount: addGiftCardCtrl.maxAmount,
                                selectedGiftCard: paymentMethodId,
                                mainPaymentMethod: options.mainPaymentMethod,
                                isUsedCashbackPoints: options.isUsedCashbackPoints,
                                availableUserCashback: options.availableUserCashback,
                                isAddingNewCard: isAddingNewCard
                            };
                            return dialog.show({
                                templateUrl: 'template/dialogs/add-gift-card/index.html',
                                controller: 'AddGiftCardCtrl',
                                controllerAs: 'addGiftCardCtrl',
                                ariaLabelledby: 'add_gift_card_title',
                                styleClass: 'add-gift-cards-dialog',
                                clickOutsideToClose: false,
                                disableClosing: true,
                                locals: { options: payload },
                                resolve: {
                                    summaryCtrl: summaryCtrl
                                }
                            });
                        } else {
                            console.log('Cannot open gift card dialog');
                            backToGiftCardsList(paymentMethodId);
                        }
                    })
                    .catch(function (error) {
                        console.log("gift_card_error_message", error);
                        addGiftCardCtrl.giftCardsData[paymentMethodId] = angular.extend({}, addGiftCardCtrl.giftCardsData[paymentMethodId],{errorMessage : 'gift_card_error_message'});
                    });
            }
            function backToGiftCardsList(paymentMethodId) {
                var redeemedGiftCardsCount = util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.cards.length') || 0;
                if(allowAddMultipleGiftCardsByTypeSettings(paymentMethodId) && redeemedGiftCardsCount > 0) {
                    var payload = {
                        giftCards: options.giftCards,
                        giftCardsData: angular.copy(addGiftCardCtrl.giftCardsData),
                        redeemedGiftCards: angular.copy(addGiftCardCtrl.carouselData.redeemedGiftCards),
                        maxAmount: addGiftCardCtrl.maxAmount,
                        selectedGiftCard: paymentMethodId,
                        mainPaymentMethod: options.mainPaymentMethod,
                        isUsedCashbackPoints: options.isUsedCashbackPoints,
                        availableUserCashback: options.availableUserCashback,
                        isAddingNewCard: false
                    };
                    return dialog.show({
                        templateUrl: 'template/dialogs/add-gift-card/index.html',
                        controller: 'AddGiftCardCtrl',
                        controllerAs: 'addGiftCardCtrl',
                        ariaLabelledby: 'add_gift_card_title',
                        styleClass: 'add-gift-cards-dialog',
                        clickOutsideToClose: false,
                        disableClosing: true,
                        locals: { options: payload },
                        resolve: {
                            summaryCtrl: summaryCtrl
                        }
                    });
                }
            }
            function removeCard(paymentMethodId, cardNumber) {
                var cards = util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.cards');
                var cardIndex = cards.findIndex(function (card) { return card.cardNumber === cardNumber; });
                if (cardIndex !== -1) {
                    addGiftCardCtrl.removedGiftCards[paymentMethodId] = cards[cardIndex];
                    cards.splice(cardIndex, 1);
                    if(cards.length === 0) {
                        delete addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId];
                        if (paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD || paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI) {
                            addGiftCardCtrl.carouselData.selectedGiftCard = addGiftCardCtrl.giftCards.length > 0 && addGiftCardCtrl.giftCards[0].paymentMethodId;
                            addGiftCardCtrl.giftCardsData[paymentMethodId] = {};
                        }
                        _adjustPointerPosition();
                    }
                    else {
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].cards = cards;
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount = _roundCurrencyFilter(cards.reduce(function (acc, card) { return acc + card.amount; }, 0));
                    }
                }
                _calculateBalanceToBePayed();

                return addGiftCardCtrl.carouselData.redeemedGiftCards;
            }

            function resetCardDetails(paymentMethodId) {
                addGiftCardCtrl.giftCardsData[paymentMethodId] = {};
                if (paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD || paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI) {
                    if(addGiftCardCtrl.giftCards.length > 0 && addGiftCardCtrl.giftCards[0].paymentMethodId) {
                        toggleSelectedGiftCard(addGiftCardCtrl.giftCards[0].paymentMethodId, 0);
                    }
                }
            }

            function checkAmount(paymentMethodId) {
                addGiftCardCtrl.giftCardsData[paymentMethodId].wrongAmountError = '';

                if(addGiftCardCtrl.giftCardsData[paymentMethodId].balance && addGiftCardCtrl.giftCardsData[paymentMethodId].amount > addGiftCardCtrl.giftCardsData[paymentMethodId].balance) {
                    addGiftCardCtrl.giftCardsData[paymentMethodId].wrongAmountError = 'amount_exceeds_balance';
                    return;
                }

                if(addGiftCardCtrl.giftCardsData[paymentMethodId].amount > addGiftCardCtrl.carouselData.balanceToBePayed) {
                    addGiftCardCtrl.giftCardsData[paymentMethodId].wrongAmountError = 'wrong_gift_card_amount_error';
                    return;
                } 
            }

            function isDisableRedeemBtn(paymentMethodId) {
                var existCvv = addGiftCardCtrl.giftCardsData[paymentMethodId].cvv,
                    existAmount = addGiftCardCtrl.giftCardsData[paymentMethodId].amount,
                    existBalance = addGiftCardCtrl.giftCardsData[paymentMethodId].balance,
                    existBalanceToBePayed = addGiftCardCtrl.carouselData.balanceToBePayed,
                    invalidAmount = addGiftCardCtrl.giftCardsData[paymentMethodId].amount <= 0 
                    || addGiftCardCtrl.giftCardsData[paymentMethodId].amount > addGiftCardCtrl.giftCardsData[paymentMethodId].balance 
                    || addGiftCardCtrl.giftCardsData[paymentMethodId].amount > addGiftCardCtrl.carouselData.balanceToBePayed;
                if (!existCvv && (
                    paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD ||
                    paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI ||
                    paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.NOFSHONIT
                )) {
                    return true;
                }
                return !existAmount || !existBalance || !existBalanceToBePayed || invalidAmount;
            }

            function isGiftCardNotEligible() {
                return (addGiftCardCtrl.carouselData.selectedGiftCard === SP_PAYMENTS.PAYMENT_METHODS.IDS.TAV_PLUS || addGiftCardCtrl.carouselData.selectedGiftCard === SP_PAYMENTS.PAYMENT_METHODS.IDS.TAV_PLUS_LIGHT) && addGiftCardCtrl.mainPaymentMethod !== SP_PAYMENTS.PAYMENT_METHODS.IDS.CREDIT_CARD;
            }

            function close () {
                var redeemedGiftCards = Object.values(addGiftCardCtrl.carouselData.redeemedGiftCards);
                if (!redeemedGiftCards || !redeemedGiftCards.length) {
                    dialog.hide({});
                    return;
                }

                if(addGiftCardCtrl.removedGiftCards) {
                    angular.extend(addGiftCardCtrl.carouselData.redeemedGiftCards, addGiftCardCtrl.removedGiftCards);
                }
                _calculateTotalGiftCard();
                dialog.hide();
            }

            function next() {
                _calculateTotalGiftCard();
                dialog.hide(addGiftCardCtrl.carouselData.redeemedGiftCards);
            }

            function _calculateTotalGiftCard() {
                // For Max Gift Card, the dialog is forced to close leading to the missing total giftCard data in summaryCtr, so we need to manually set the totalGiftCard before closing
                if (addGiftCardCtrl.carouselData.redeemedGiftCards[SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD] ||
                    addGiftCardCtrl.carouselData.redeemedGiftCards[SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI]
                ) {
                    summaryCtrl.totalPriceForPointsCalculation += summaryCtrl.totalGiftCards || 0;
                    summaryCtrl.totalGiftCards = 0;
                    summaryCtrl.redeemedGiftCards = addGiftCardCtrl.carouselData.redeemedGiftCards;
                    summaryCtrl.redeemedGiftCardIds = Object.keys(summaryCtrl.redeemedGiftCards);
                    angular.forEach(summaryCtrl.redeemedGiftCardIds, function (giftCardId) {
                        summaryCtrl.totalGiftCards += summaryCtrl.redeemedGiftCards[giftCardId].amount;
                    });

                    if(summaryCtrl.userCashbackLoyalty) {
                        summaryCtrl.totalPriceForPointsCalculation -= summaryCtrl.totalGiftCards || 0;
                        summaryCtrl.availableUserCashback -= summaryCtrl.totalGiftCards || 0;
                        _calculateUserPoints();
                    }
                }
            }

            function _calculateUserPoints() {
                if(summaryCtrl.totalPriceForPointsCalculation > 0) {
                    var points = summaryCtrl.totalPriceForPointsCalculation / summaryCtrl.activeCashbackLoyalty.moneyToPointRatio;
                    summaryCtrl.currentOrderPoints = Number(points.toFixed(2));
                } else {
                    summaryCtrl.currentOrderPoints = null;
                }
            }

            function _setGiftCardsData() {
                angular.forEach(addGiftCardCtrl.giftCards, function (giftCard) {
                    if (!addGiftCardCtrl.giftCardsData[giftCard.paymentMethodId]) {
                        addGiftCardCtrl.giftCardsData[giftCard.paymentMethodId] = {
                            number: null,
                            balance: null
                        };
                    }
                });
            }

            function _calculateBalanceToBePayed() {
                addGiftCardCtrl.carouselData.balanceToBePayed = _roundCurrencyFilter(addGiftCardCtrl.total);
                var keys = Object.keys(addGiftCardCtrl.carouselData.redeemedGiftCards);
                angular.forEach(keys, function (giftCardId) {
                    var redeemedGiftCardAmount = addGiftCardCtrl.carouselData.redeemedGiftCards[giftCardId] ? addGiftCardCtrl.carouselData.redeemedGiftCards[giftCardId].amount : 0;
                    addGiftCardCtrl.carouselData.balanceToBePayed = _roundCurrencyFilter(addGiftCardCtrl.carouselData.balanceToBePayed - redeemedGiftCardAmount);
                });
            }

            function _setGiftCardGeneralDisplay() {
                addGiftCardCtrl.giftCardGeneralDisplay = Config.retailer.settings.giftCardDisplay ? util.tryParseJson(Config.retailer.settings.giftCardDisplay)[Config.language.culture] : {};
            }

            function _setGiftCardDisplay(isAddingNewCard) {
                var giftCardDisplay = Config.retailer.settings.giftCardDisplay ? util.tryParseJson(Config.retailer.settings.giftCardDisplay) : {}

                if(addGiftCardCtrl.carouselData.selectedGiftCard) {
                    if(giftCardDisplay[Config.language.culture]) {
                        if(giftCardDisplay[Config.language.culture].config) {
                            addGiftCardCtrl.giftCardDisplay = giftCardDisplay[Config.language.culture].config[addGiftCardCtrl.carouselData.selectedGiftCard];

                            if(!addGiftCardCtrl.giftCardDisplay) addGiftCardCtrl.giftCardDisplay = {}

                            var MAX_TRUNCATED_LEGAL_TEXT_LENGTH = 256;

                            if(addGiftCardCtrl.giftCardDisplay && addGiftCardCtrl.giftCardDisplay.legalText) {
                                addGiftCardCtrl.originalLegalText = addGiftCardCtrl.giftCardDisplay.legalText;
                                if(addGiftCardCtrl.giftCardDisplay.legalText.length > MAX_TRUNCATED_LEGAL_TEXT_LENGTH) {
                                    addGiftCardCtrl.truncatedLegalText = addGiftCardCtrl.giftCardDisplay.legalText.slice(0, MAX_TRUNCATED_LEGAL_TEXT_LENGTH) + '...';
                                    addGiftCardCtrl.giftCardDisplay.legalText = addGiftCardCtrl.truncatedLegalText;

                                    addGiftCardCtrl.giftCardDisplay.showEllipsisBtn = true;
                                }
                            }

                            addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore = false;
                        }
                    }
                    if(isAddingNewCard) {
                        addGiftCardCtrl.carouselData.redeemedGiftCards[addGiftCardCtrl.carouselData.selectedGiftCard] =
                        angular.extend({}, addGiftCardCtrl.carouselData.redeemedGiftCards[addGiftCardCtrl.carouselData.selectedGiftCard], { isAddingNewCard: true });
                    }
                    _adjustPointerPosition()
                }
            }

            function _adjustPointerPosition() {
                $timeout(function () {
                    var itemSelectedElm = document.querySelector('.gift-card.open-card');
                    var itemSelectedRect = itemSelectedElm ? itemSelectedElm.getBoundingClientRect() : null;
                    var cardDetailsWrapperElm = document.querySelector('.card-details-wrapper');
                    var cardDetailsWrapperRect = cardDetailsWrapperElm ? cardDetailsWrapperElm.getBoundingClientRect() : null;

                    if (itemSelectedRect && cardDetailsWrapperRect) {
                        var cardPointer = document.querySelector('.card-pointer');
                        var newPos = itemSelectedRect.x - cardDetailsWrapperRect.x < cardDetailsWrapperRect.width - itemSelectedRect.width / 2 ? itemSelectedRect.x - cardDetailsWrapperRect.x + itemSelectedRect.width / 2 : itemSelectedRect.width / 2;
                        cardPointer.style.left = newPos - 10 + 'px';
                    }
                }, 0);
            }

            function _calculateTextTruncation() {
                $timeout(function() {
                    var legalTextEl = document.querySelector('.legal-text-wrapper > span.text');
                    if(legalTextEl) {
                        var scrollHeight = legalTextEl.scrollHeight;
                        var clientHeight = legalTextEl.clientHeight;

                        if(scrollHeight > clientHeight) {
                            addGiftCardCtrl.showSeeMoreBtn = true;
                        }
                    }
                }, 0)
            }

            function _reorderAndIndexGiftCards(giftCards) {
                if (!addGiftCardCtrl.giftCardOrders || !addGiftCardCtrl.giftCardOrders.length) {
                    // If gift card orders has not been configured in BO, use order of gift cards responded from API
                    angular.forEach(giftCards, function (giftCard, index) {
                        addGiftCardCtrl.giftCardsIndex[giftCard.paymentMethodId] = index;
                    });

                    return giftCards;
                }

                var mapPaymentIdToGiftCard = {}
                giftCards.forEach(function (giftCard) {
                    mapPaymentIdToGiftCard[giftCard.paymentMethodId] = giftCard
                })

                var giftCardsNewOrder = [];
                angular.forEach(addGiftCardCtrl.giftCardOrders, function (paymentMethodId) {
                    if (!mapPaymentIdToGiftCard[paymentMethodId]) return;
                    giftCardsNewOrder.push(mapPaymentIdToGiftCard[paymentMethodId])
                    addGiftCardCtrl.giftCardsIndex[paymentMethodId] = giftCardsNewOrder.length - 1;
                });

                return giftCardsNewOrder;
            }
            
            function isRedeemedGiftCardsExist() {
                var redeemedGiftCardsValues = Object.values(addGiftCardCtrl.carouselData.redeemedGiftCards);
                if (!redeemedGiftCardsValues.length) {
                    return false;
                } else if (addGiftCardCtrl.carouselData.selectedGiftCard !== SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD && addGiftCardCtrl.carouselData.selectedGiftCard !== SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI) {
                    return !(util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, addGiftCardCtrl.carouselData.selectedGiftCard + '.isAddingNewCard') || false);
                }

                return (util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, addGiftCardCtrl.carouselData.selectedGiftCard + '.cards.length') || 0) > 0
                    && !(util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, addGiftCardCtrl.carouselData.selectedGiftCard + '.isAddingNewCard') || false);
            }

            function isValidateCvv(){
                return !isNaN(addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv) && addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv.length > 0;
            }

            function findGiftCard(paymentMethodId) {
                var index = addGiftCardCtrl.giftCardsIndex[paymentMethodId];
                if (isNaN(index) || index < 0) {
                    return {};
                }

                return addGiftCardCtrl.giftCards[index];
            }

            function _cutText(text, length) {
                if (text.length > length) {
                    return text.substring(0, length) + '...';
                }
                return text;
            }

            function _initGiftCardsCarousel() {
                var giftCardDisplay = Config.retailer.settings.giftCardDisplay ? util.tryParseJson(Config.retailer.settings.giftCardDisplay) : {};
                addGiftCardCtrl.giftCards = options.giftCards ? options.giftCards : [];

                // If settings allow display images, load images
                if (addGiftCardCtrl.isShowImagesGiftCards &&
                    giftCardDisplay[Config.language.culture] &&
                    giftCardDisplay[Config.language.culture].config
                ) {
                    addGiftCardCtrl.giftCards.forEach(function (giftCard) {
                        giftCard.giftCardCover = giftCardDisplay[Config.language.culture].config[giftCard.paymentMethodId] ? giftCardDisplay[Config.language.culture].config[giftCard.paymentMethodId].giftCardCover : '';
                    });
                }

                // Load Accessibilities for gift cards
                addGiftCardCtrl.giftCards.forEach(function (giftCard) {
                    giftCard.accessibilityName = addGiftCardCtrl.giftCardAccessibilities[giftCard.paymentMethodId] && addGiftCardCtrl.giftCardAccessibilities[giftCard.paymentMethodId][Config.language.id] ? addGiftCardCtrl.giftCardAccessibilities[giftCard.paymentMethodId][Config.language.id] : '';
                });

                addGiftCardCtrl.giftCards = _reorderAndIndexGiftCards(addGiftCardCtrl.giftCards);

                var selectedGiftCard = options.selectedGiftCard || addGiftCardCtrl.giftCards[0].paymentMethodId;
                var indexOfSelectedGiftCard = addGiftCardCtrl.giftCardsIndex.hasOwnProperty(selectedGiftCard) ? addGiftCardCtrl.giftCardsIndex[selectedGiftCard] : 0;
                addGiftCardCtrl.carouselData = {
                    selectedGiftCard: selectedGiftCard,
                    balanceToBePayed: 0,
                    redeemedGiftCards: options.redeemedGiftCards || {},
                    selectedGiftCardData: addGiftCardCtrl.giftCards[indexOfSelectedGiftCard] || {},
                    isShowImagesGiftCards: addGiftCardCtrl.isShowImagesGiftCards
                };
            }

            _listeners.push($scope.$watch(function (){
                return addGiftCardCtrl.giftCardsData && addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard] && addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv
            }, function() {
                if(
                  (addGiftCardCtrl.carouselData.selectedGiftCard === $rootScope.SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI || addGiftCardCtrl.carouselData.selectedGiftCard === $rootScope.SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD) &&
                  addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard]
                ) {
                    if (!addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv && addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired) {
                        addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired = false;
                        return;
                    }
                    if (addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired) {
                        if (
                            addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv &&
                            addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv.length > 2 &&
                            !isNaN(addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv)
                        ) {
                            addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired = false;
                        }
                    } else {
                        // if(isNaN(addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv) || addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv.length < 3) {
                        //     addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired = true;
                        // }
                    }
                }
            }));

            util.destroyListeners($scope, _listeners);
    }]);
})(angular, app);
